import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Form from "../common/Form";
import TextInput from "../common/TextInput";
import TextAreaInput from "../common/TextAreaInput";
import Row from "../common/Row";
import DateInput from "../common/DateInput";
import AutoComplete from "../common/AutoComplete";
import Files from "../common/Files";
import { FileComponentNames, COLOR_BLUE } from "../../constants/ComponentConstants";
import { getPropertyFilesComponentProps } from "../../components/common/FilesHelperUtil";
import AdresWizard from "../adresWizard/adresWizard";
import CheckBoxWithChild from "../common/CheckBoxWithChild";
import AdresFormItem from "../sportenophetwerk/formitems/AdresFormItem";
import Col from "../common/Col";
import FriendlyCaptcha from "../common/FriendlyCaptcha";

const MeldingenForm = (props) => {
    const {
        meldingenModel,
		onAdresSave,
        onChange,
		onChangeCheckbox,
        onSave,
        onDropFiles,
        onRemoveFile,
		onCaptchaVerified,
        fileDownloadUrl,
        filesComponent,
		sendButtonDisabled,
        errors
    } = props;

    const filesMimeTypes = 'application/vnd.ms-excel,application/msexcel, application/x-excel, application/x-msexcel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/pdf, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/msword, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, image/png, image/jpeg, image/jpeg, image/gif, image/tiff';
    const filesExtensions = 'pdf, xls, xlsx, doc, docx, ppt, pptx, jpeg, jpg, gif, png, tiff';
    const filesProps = getPropertyFilesComponentProps("Bijlagen", FileComponentNames.MELDINGEN, fileDownloadUrl, filesComponent, null, false, onDropFiles, onRemoveFile, onChange, {
        mimeTypes: filesMimeTypes,
        extensions: filesExtensions
    });

    return (
        <Fragment>
            <Form
                name="meldingen"
                onLeftButtonClick={onSave}
                leftButtonLabel={"Verzend"}
                leftButtonDisabled={sendButtonDisabled}
                isNotRequired
                headerVisible={false}>
                <div style={{ padding: "25px" }}>
                    <p style={{ margin: "10px" }}>Alle velden zijn verplicht tenzij anders aangegeven.</p>
                    <Row>
                        <TextInput
                            name="voornaam"
                            label="Voornaam"
                            value={meldingenModel.voornaam}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['voornaam'] : ""}
                        />
                        <TextInput
                            name="achternaam"
                            label="Achternaam"
                            value={meldingenModel.achternaam}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['achternaam'] : ""}
                        />
                    </Row>
					<Row>
						<Col size={12}>
							<CheckBoxWithChild
								name="meldingInNaamVanAnderePersoon"
								label="Ik maak deze melding in naam van een andere persoon"
								value={meldingenModel.meldingInNaamVanAnderePersoon}
								onChange={onChangeCheckbox} />
						</Col>
					</Row>
                    <br />
					<Row>
						<AdresWizard onSave={onAdresSave} model={meldingenModel.adres} errors={errors} />
					</Row>
					<br />
                    <Row>
                        <TextInput
                            name="organisatie"
                            label="Organisatie (optioneel)"
                            value={meldingenModel.organisatie}
                            onChange={onChange}
                            validationMessage={errors ? errors['organisatie'] : ""}
                        />
                    </Row>
                    <Row>
                        <TextInput
                            name="telefoon"
                            label="Telefoon (optioneel)"
                            value={meldingenModel.telefoon}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['telefoon'] : ""}
                        />
                        <TextInput
                            name="gsm"
                            label="GSM (optioneel)"
                            value={meldingenModel.gsm}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['gsm'] : ""}
                        />
                    </Row>
                    <Row>
                        <TextInput
                            name="email"
                            label="E-mail"
                            value={meldingenModel.email}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['email'] : ""}
                        />
                        <TextInput
                            name="bevestigEmail"
                            label="Bevestig e-mail"
                            value={meldingenModel.bevestigEmail}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['bevestigEmail'] : ""}
                        />
                    </Row>
                    <Row>
                        <DateInput
                            name="datum"
                            label="Datum"
                            value={meldingenModel.datum}
                            onChange={onChange}
                            size={6}
                            validationMessage={errors ? errors['datum'] : ""}
                        />
                    </Row>
                    <br />
                    <TextAreaInput
                        name="omschrijving"
                        label="Omschrijving"
                        value={meldingenModel.omschrijving}
                        onChange={onChange}
                        height={5}
                        validationMessage={errors ? errors['omschrijving'] : ""}
                    />
                    <Files {...filesProps} />
                    <br />
                    <p>
						Sport Vlaanderen verwerkt je persoonsgegevens in het kader van het behandelen van de melding. We bewaren jouw gegevens voor een periode van 10 jaar na afhandeling van de melding. Je kan altijd mailen om te vragen welke persoonsgegevens we verwerken. We vragen dan een bewijs van je identiteit zodat we je gegevens niet meedelen aan iemand die er geen recht op heeft. De gegevens worden verwerkt in een meldingssysteem.
                </p>
                    <br />
                    <p>
                        Als je vragen hebt over de manier waarop we jouw persoonsgegevens verwerken, kun je contact opnemen met het DPO-team van Sport Vlaanderen door te mailen naar <a style={{ color: COLOR_BLUE, textDecoration: 'underline' }} target={"_blank"} href={"mailto:privacy@sport.vlaanderen"}>privacy@sport.vlaanderen</a> Ben je het niet eens met de manier waarop we jouw gegevens verwerken, dan kan je je wenden tot de bevoegde  toezichthoudende  autoriteit.  Ons  beleid  op  het  vlak  van  gegevensverwerking  vind  je  op <a style={{ color: COLOR_BLUE, textDecoration: 'underline' }} target={"_blank"} href={"https://www.sport.vlaanderen/privacybeleid/"}>https://www.sport.vlaanderen/privacybeleid/</a>.
                </p>
					<br/>
				<p>
					<FriendlyCaptcha onVerified={onCaptchaVerified}/>
				</p>
				</div>
            </Form>
        </Fragment>
    );
};

MeldingenForm.propTypes = {
    meldingenModel: PropTypes.object,
	onAdresSave: PropTypes.func,
    onChange: PropTypes.func,
	onChangeCheckbox: PropTypes.func,
    onSave: PropTypes.func,
    onDropFiles: PropTypes.func,
	onCaptchaVerified: PropTypes.func,
    onRemoveFile: PropTypes.func,
    fileDownloadUrl: PropTypes.string,
    filesComponent: PropTypes.array,
	sendButtonDisabled: PropTypes.bool,
    errors: PropTypes.object
};

export default MeldingenForm;
